import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import merge from 'lodash-es/merge';
import * as qs from 'qs';

import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {ChartParams} from "app/views/chart/chart.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {FilterParams} from "../../models/filter_form.model";
import {ModalService} from "../../views/modal/base_modal.component";
import {MailDetailComponent} from "./mail_detail.component";
import {MailService} from "app/mails/mail.service";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "../../lib/helper.service";
import dictionaries from "../../../dict/static.json";
import { MailTabGroup } from "app/models/mail";
import { from, of, Subscription } from "rxjs";
import { catchError, concatMap, map, switchMap, tap, toArray } from "rxjs/operators";
import { ITotals } from "../../models/responce_result.model";


function getGAName(name: string): string {
	return `${name}-GA`;
}

class MailRow {
	_isShowSent: boolean = true;
	
	_isShowReaded: boolean = false;
	
	constructor(public chart: ChartParams, public name: any) {
		
	}
	
	toogleChart(name: string) {
		this.chart.options.$toggle.next(name);
	}
	
	get isShowSent() { return this._isShowSent; }
	set isShowSent(value: boolean) {
		this._isShowSent = value;
		
		this.toogleChart(this.name);
	}
	
	
	get isShowReaded() { return this._isShowReaded; }
	set isShowReaded(value: boolean) {
		this._isShowReaded = value;
		
		this.toogleChart(getGAName(this.name));
	}
}


class MailCategoryModel {
	public name: string = 'category 1';

	public chart: ChartParams = new ChartParams({
		isChartFilter: true
	});

	public table: MailRow[] = [];
	
	public titlePrintType: string = 'name';
	
	constructor(data: any) {
		this.setData(data);
	}
	
	setData(data: any) {
		this.name                                = data.name;
		this.chart.data                          = data.charts;
		
		merge(this.chart.options, data.options);
		
		this.chart.options.filter.datePeriodList = [];
		
		let table = data.table || [];
		this.chart.options.showLabels            = table;
		this.chart.options.lazyRender            = ['domain', 'paids', 'badges'].includes(data.name);
		this.table                               = table.map(r => new MailRow(this.chart, r));
	}
}


const mailGroups = <MailTabGroup[]>dictionaries.mailGroups;

interface IMailTotal extends ITotals {
	totalSent: number;
	totalNoSent: number;
}

interface ISubjectFilterItem {
	i18n: string;
	subjectType: string;
}

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html'
})
export class MailComponent extends BaseComponent {
	// по дефолту мы не учитываем в отправках домен яндекса, потому что прочтения по ним не приходят в ga
	defaultEmailFilter = 'allExceptYandex';

	addFilterParams = {
		dateFilters : ['dateSentMail'],
		email: this.defaultEmailFilter,
	};
	
	public totalLoader: boolean = false;
	
	public totalSent: number = 0;
	
	public totalNoSent: number = 0;
	
	public stats: MailCategoryModel[] = [];
	
	public names = {};
	public subjects: ISubjectFilterItem[] = [];
	
	public chartPeriod: string = '30days';
	
	public tabs: string[] = mailGroups.map(m => m.tab);
	public tab: string = 'main';
	
	public i18nForSubject = {};

	public $s: Subscription;
	
	public subjectTypeConfig = {
		config: {
			valueField  : 'subjectType',
			labelField  : ['i18n', 'subjectType'],
			searchField : ['subjectType', 'i18n'],
			render      : {
				option: function(item) {
					return `<div>${item.i18n} (${item.subjectType})</div>`;
				},
				item: function(item) {
					return `<div>${item.i18n} (${item.subjectType})</div>`;
				},
			},
			maxItems    : 16,
		},
		options: null
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public mailService: MailService,
	) {
		super(eventsService, mailService, activatedRoute, filter, translate);
		
		const me = this;

		me.i18nForSubject['name'] = 'Тема';
		me.i18nForSubject['service name'] = 'subjectType';

		const subjects = {};
		me.names = mailGroups.reduce(
			function(names, tab) {
				tab.groups.forEach(group => {
					group.subjectTypes.forEach(subjectType => {
						names[subjectType] = me.__a('mails.mail.' + subjectType);
						names[getGAName(subjectType)] = getGAName(
							me.__a('mails.mail.' + subjectType)
						);
						
						subjects[names[subjectType]] = subjectType;
					})
				});
				
				return names;
			},
			{}
		);
		me.subjects = Object.keys(subjects)
			.map(i18n => ({ i18n, subjectType: subjects[i18n], }));
		
		me.subjectTypeConfig.options = me.subjects;
	}
	
	
	async getData() {
		const me = this;

		const fp = me.filter.filterParams;
		
		me.tab = fp.tab;
		
		if (me.$s) {
			me.$s.unsubscribe();
			me.$s = null;
		}

		me.$s = of(fp)
			.pipe(
				
				// Общие цифры
				tap(() => me.totalLoader = true),
				switchMap(() => me.mailService.mail.total<IMailTotal>(fp)),
				map(({ totalSent, totalNoSent }) => {
					me.totalSent = totalSent;
					me.totalNoSent = totalNoSent;
					me.totalLoader = true;

					// Список графиков
					// TODO Подумать как всё таки вызвать явно destroy у c3js instance-а
					me.stats = me.getChartList();
				}),
				switchMap(() => from(me.stats).pipe(
					concatMap(
						stat => {
							stat.chart.showLoader();
							
							return me.mailService.mail.chart(
								{ ...fp, categoryName: stat.name, }
								)
								.pipe(
									map(data => stat.setData(data)),
									tap(() => stat.chart.hideLoader()),
								);
						}
					),
					toArray(),
				)),
				catchError(err => {
					me.eventsService.broadcast('mail-error', err);

					throw err;
				})
			)
			.subscribe(() => {
				console.log('mail load end', me.stats.length);
			});
	}
	
	
	async applyFilters() {
		const
			params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];
		
		params['tab'] = this.tab;
		const paramsAsStr = qs.stringify(params, { encode: false });
		
		this.router.navigateByUrl(`${url}?${paramsAsStr}`, { relativeTo: this.activatedRoute });
	}
	
	
	async resetFilters() {
		this.filter.filterParams = new FilterParams();
		this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params: FilterParams = merge({}, this.filter.getDiffParams(this.filter.filterParams)),
			url = this.router.url.split('?')[0];
		
		delete params.dateFilters;
		delete params.dateFilterParams;
		
		this.router.navigate([url], { relativeTo: this.activatedRoute, queryParams: params });
	}
	
	
	changeTitleForChart(stat, titlePrintType) {
		stat.titlePrintType = titlePrintType;
		
		if (stat.titlePrintType === 'name') {
			stat.chart.setOptions({ names: this.names });
		} else {
			stat.chart.setOptions({ names: null });
			stat.chart.setOptions({ names: {} });
		}
	}
	
	
	async updateData(filter, categoryName) {
		const
			me           = this,
			filterParams = merge({}, me.filter.filterParams, filter);
		
		const { charts } = await me.mailService.mail.chart(
			{ ...filterParams, categoryName, }
		).toPromise();
		
		me.stats.forEach(stat => {
			if (stat.name === categoryName) {
				stat.chart.data = charts;
			}
		});
	}
	
	
	async showTable(stat) {
		const
			me       = this,
			modalRef = me.modalService.open(MailDetailComponent, {
				title     : stat.name,
				isLoad    : true,
			}, {size: 'hg'});
		
		const { stats } = await me.mailService.mail.detail({
			...me.filter.filterParams, categoryName: stat.name,
		}).toPromise();
		modalRef.componentInstance.stats = stats;
		modalRef.componentInstance.isLoad = false;
	}


	getChartList() {
		const me = this;

		const tab = mailGroups.find(tab => me.tab === tab.tab);
		
		// UPDATE:
		// Тут такое нужно, поскольку про группу "total" вкладки main - знает только код тут, на клиенте.
		// А на беке, и в других отчётах группа total не нужна.
		if (me.tab === 'main' && tab.groups[0].group !== 'total') {
			tab.groups.unshift({
				group: "total",
				subjectTypes: ['sent', 'noSent']
			});
		}

		// По факту мы проходимся по списку графиков два раза.
		// Это сделано для того, чтобы развязать по времени:
		// 1. инициализацию графика
		// 2. хождение за данными
		// 3. построение графика по данным
		// Иначе браузер не вывозит отрисовку страницы
		
		const stats = [];
		
		for(const chart of tab.groups) {
			const stat = new MailCategoryModel({
				name: chart.group,
				options: {
					names: me.names,
					// size: {
					// 	height: me.tab === 'other' && chart.group === 'system' ? 665 : 380,
					// },
				},
			});

			if (chart.group === 'total') {
				stat.chart.setOptions({
					axes: {
						sent: 'y',
						noSent: 'y2',
					},
					axis: {
						y: {
							min   : 1,
							ticks : 5,
							label: {
								text     : 'sent',
								position : 'outer-middle'
							}
						},
						y2: {
							show: true,
							label: {
								text     : 'noSent',
								position : 'outer-middle'
							}
						}
					},
					names: me.names,
				});
			}

			stats.push(stat);
		}
		
		return stats;
	}
	
	
	ngOnDestroy() {
		super.ngOnDestroy();

		this.stats = [];
	}
}

